<script>
import axios from '@/utils/axios';

export default {
  emits: ['updated'],
  data() {
    return {
      isEdit: false,
      viewMode: false,
      editId: null,
      deleteRow: null,
      submitting: false,
      errors: {},
      form: {
        customer_id: '',
        user_id: '',
        name: '',
        mobile: '',
        address: '',
        file_number: '',
        order_date: '',
        dispatch_date: '',
        windows_quantity: '',
        glass_status: '',
        remark: '',
        delivery_status: 'ready_for_dispatch',
      },
      users: [],
    };
  },

  mounted() {
    this.fetchUsers();
  },

  methods: {

    openCreateForCustomer(customerId) {
    this.resetForm();
    this.form.customer_id = customerId;
},

    resetForm() {
      this.isEdit = false;
      this.viewMode = false;
      this.editId = null;
      this.errors = {};
      this.form = {
        customer_id: '',
        user_id: '',
        name: '',
        mobile: '',
        address: '',
        file_number: '',customer_id: '',
        order_date: '',
        dispatch_date: '',
        windows_quantity: '',
        glass_status: '',
        remark: '',
        delivery_status: 'ready_for_dispatch',
      };
    },

    async fetchUsers() {
      try {
        const response = await axios.get('/users?per_page=500');
        this.users = response.data.data.data || response.data.data || [];
      } catch (error) {
        console.log('Failed to load users:', error.message);
      }
    },

    openCreate() {
      this.resetForm();
    },

    async openEdit(id) {
      this.resetForm();
      this.isEdit = true;
      this.editId = id;
      try {
        const response = await axios.get(`/customer-dispatches/${id}`);
        const d = response.data.data;
        this.form = {
          customer_id: d.customer_id,
          user_id: d.user_id,
          name: d.name,
          mobile: d.mobile,
          address: d.address,
          file_number: d.file_number,
          order_date: d.order_date,
          dispatch_date: d.dispatch_date,
          windows_quantity: d.windows_quantity,
          glass_status: d.glass_status || '',
          remark: d.remark || '',
          delivery_status: d.delivery_status,
        };
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    async openView(id) {
      this.resetForm();
      this.isEdit = true;
      this.editId = id;
      try {
        const response = await axios.get(`/customer-dispatches/${id}`);
        const d = response.data.data;
        this.form = {
          user_id: d.user_id,
          name: d.name,
          mobile: d.mobile,
          address: d.address,
          file_number: d.file_number,
          order_date: d.order_date,
          dispatch_date: d.dispatch_date,
          windows_quantity: d.windows_quantity,
          glass_status: d.glass_status || '',
          remark: d.remark || '',
          delivery_status: d.delivery_status,
        };
        this.viewMode = true;
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    openDelete(row) {
      this.deleteRow = row;
    },

    async submitForm() {
      if (this.submitting) return;
      this.submitting = true;
      this.errors = {};
      try {
        const payload = { ...this.form };
        if (this.isEdit) {
          await axios.put(`/customer-dispatches/${this.editId}`, payload);
          this.$swalToast('Dispatch updated successfully', 'success');
        } else {
          await axios.post('/customer-dispatches', payload);
          this.$swalToast('Dispatch created successfully', 'success');
        }
        this.$closeModal('customer_dispatch_modal');
        this.$emit('updated');
      } catch (error) {
  if (error.type == 'validation') {
    this.errors = error.errors;
  } else {
    this.$swalToast(error.message, 'error');
  }
      } finally {
        this.submitting = false;
      }
    },

    async deleteDispatch() {
      if (!this.deleteRow) return;
      try {
        await axios.delete(`/customer-dispatches/${this.deleteRow.id}`);
        this.$swalToast('Dispatch deleted successfully', 'success');
        this.$closeModal('customer_dispatch_delete_modal');
        this.deleteRow = null;
        this.$emit('updated');
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

    async updateStatus(id) {
      try {
        await axios.patch(`/customer-dispatches/${id}/status`, { delivery_status: 'dispatched' });
        this.$swalToast('Status updated to Dispatched', 'success');
        this.$emit('updated');
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },

  },
};
</script>

<template>

  <!-- Create/Edit/View Modal -->
<div class="modal fade" id="customer_dispatch_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ viewMode ? 'View' : (isEdit ? 'Edit' : 'Add') }} Customer Dispatch</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
 
            <div class="col-md-6 mb-3">
              <label class="form-label">Assigned User <span class="text-danger">*</span></label>
              <select class="form-select" :class="{ 'is-invalid': errors.user_id }" v-model="form.user_id" :disabled="viewMode">
                <option value="">Select User</option>
                <option v-for="u in users" :key="u.id" :value="u.id">{{ u.name }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.user_id">{{ errors.user_id[0] }}</div>
            </div>
 
            <!-- <div class="col-md-6 mb-3">
              <label class="form-label">Customer Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.name }" v-model="form.name" placeholder="Enter customer name" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
            </div> -->
 
            <!-- <div class="col-md-6 mb-3">
              <label class="form-label">Mobile <span class="text-danger">*</span></label>
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.mobile }" v-model="form.mobile" placeholder="Enter mobile number" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.mobile">{{ errors.mobile[0] }}</div>
            </div> -->
 
            <div class="col-md-6 mb-3">
              <label class="form-label">File Number <span class="text-danger">*</span></label>
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.file_number }" v-model="form.file_number" placeholder="Enter file number" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.file_number">{{ errors.file_number[0] }}</div>
            </div>
 
            <!-- <div class="col-md-12 mb-3">
              <label class="form-label">Address</label>
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.address }" v-model="form.address" placeholder="Enter address" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.address">{{ errors.address[0] }}</div>
            </div> -->
 
            <div class="col-md-6 mb-3">
              <label class="form-label">Order Date <span class="text-danger">*</span></label>
              <input type="date" class="form-control" :class="{ 'is-invalid': errors.order_date }" v-model="form.order_date" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.order_date">{{ errors.order_date[0] }}</div>
            </div>
 
            <div class="col-md-6 mb-3">
              <label class="form-label">Dispatch Date <span class="text-danger">*</span></label>
              <input type="date" class="form-control" :class="{ 'is-invalid': errors.dispatch_date }" v-model="form.dispatch_date" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.dispatch_date">{{ errors.dispatch_date[0] }}</div>
            </div>
 
            <div class="col-md-6 mb-3">
              <label class="form-label">Windows Quantity <span class="text-danger">*</span></label>
              <input type="number" class="form-control" :class="{ 'is-invalid': errors.windows_quantity }" v-model="form.windows_quantity" placeholder="Enter quantity" min="0" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.windows_quantity">{{ errors.windows_quantity[0] }}</div>
            </div>
 
            <div class="col-md-6 mb-3">
              <label class="form-label">Glass Status</label>
              <input type="text" class="form-control" :class="{ 'is-invalid': errors.glass_status }" v-model="form.glass_status" placeholder="Enter glass status" :disabled="viewMode" />
              <div class="invalid-feedback" v-if="errors.glass_status">{{ errors.glass_status[0] }}</div>
            </div>
 
            <div class="col-md-12 mb-3">
              <label class="form-label">Remark</label>
              <textarea class="form-control" :class="{ 'is-invalid': errors.remark }" v-model="form.remark" rows="2" placeholder="Enter remark" :disabled="viewMode"></textarea>
              <div class="invalid-feedback" v-if="errors.remark">{{ errors.remark[0] }}</div>
            </div>
 
            <div class="col-md-6 mb-3" v-if="isEdit">
              <label class="form-label">Delivery Status</label>
              <select class="form-select" :class="{ 'is-invalid': errors.delivery_status }" v-model="form.delivery_status" :disabled="viewMode">
                <option value="ready_for_dispatch">Ready for Dispatch</option>
                <option value="dispatched">Dispatched</option>
              </select>
              <div class="invalid-feedback" v-if="errors.delivery_status">{{ errors.delivery_status[0] }}</div>
            </div>
 
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">{{ viewMode ? 'Close' : 'Cancel' }}</button>
          <button v-if="!viewMode" type="button" class="btn btn-primary" @click="submitForm()" :disabled="submitting">
            {{ submitting ? 'Saving...' : (isEdit ? 'Update' : 'Save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Confirmation Modal -->
  <div class="modal fade" id="customer_dispatch_delete_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center py-4">
          <div class="mb-3">
            <i class="ti ti-trash text-danger" style="font-size: 40px;"></i>
          </div>
          <h5>Delete Dispatch</h5>
          <p class="text-muted mb-0">Are you sure you want to delete dispatch for <strong>{{ deleteRow?.name }}</strong> ({{ deleteRow?.file_number }})?</p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" @click="deleteDispatch()">Delete</button>
        </div>
      </div>
    </div>
  </div>

</template>